import { STATUS_TYPE } from '../../../enum';
import { ServiceCategory } from '../../serviceCategory/api/interface';
import { ServiceVendor } from '../../serviceVendor/api/interface';

export interface ServiceProductVariation {
  id?: string;
  labelEn: string;
  labelAr: string;
  descriptionEn?: string;
  descriptionAr?: string;
  priceDelta: number | string;
  /** Multi-day package length starting on event date (default 1). */
  durationDays?: number | string;
  position: number | string;
  activeState: boolean;
}

export interface ServiceProduct {
  id: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  images: string[];
  basePrice: number | string;
  orderAvailabilityGapDays: number | string;
  maxQty: number | string;
  dailyCapacity: number | string | null;
  specialRequestEnabled?: boolean;
  position: number | string;
  activeState: boolean;
  categoryId: string;
  vendorId: string;
  service_category?: ServiceCategory;
  service_vendor?: ServiceVendor;
  variations?: ServiceProductVariation[];
}

export interface FindServiceProduct {
  search?: string;
  categoryId?: string;
  vendorId?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchServiceProduct {
  id?: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  images: string[];
  basePrice: string;
  orderAvailabilityGapDays: string;
  maxQty: string;
  dailyCapacity: string;
  specialRequestEnabled?: boolean;
  position: string;
  activeState: boolean;
  categoryId: string;
  vendorId: string;
  variations: ServiceProductVariation[];
}

interface InitialState {
  data: ServiceProduct[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
